module.exports = __webpack_public_path__ + "static/media/CodeNext-Trial-ExtraBold.fb85c4d4.ttf";